export enum Step {
    ONBOARDING,
    CREATE_ORGANIZATION,
    AGENT_SETUP
}
